<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <div class="form-keepnumber" v-if="mode == 'portability'">
        <div class="custom-select">
          <select id="portability">
            <option value="0">{{ content["f2g.simorder.provider"] }}</option>
            <option value="1">Vodafone</option>
            <option value="2">Cosmote</option>
          </select>
          <span id="providerError" class="element-not-match"></span>
        </div>
        <div class="form-field">
          <ValidationProvider
            :name="content['f2g.simorder.portabilitymsisdn']"
            :rules="{ required: true, regex: /^[6][9][0-9]{8}$/ }"
            v-slot="{ errors }"
          >
            <label class="form-label" for="portabilitymsisdn">{{
              content["f2g.simorder.portabilitymsisdn"]
            }}</label>
            <input
              type="text"
              id="portabilitymsisdn"
              class="overlay-input-text form-input"
              v-model="portability.msisdn"
              v-on:click="handleInputClick($event)"
              v-on:focus="handleInputClick($event)"
              v-on:blur="handleBlur($event, portability.msisdn)"
            />
            <span class="element-not-match">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
      </div>
      <div class="join-steps" v-show="mode != ''">
        <div class="mini-title-blue">
          {{ content["f2g.simorder.step2"] }}
        </div>
        <div class="title-overlay4">
          {{ content["f2g.simorder.step2title"] }}
        </div>
        <div class="all-boxes-card-amount">
          <div
            class="box-card-amount"
            v-for="product in prepaidProducts"
            :key="product"
            @click="selectProduct($event)"
            :id="product.id"
            :style="[product.productDescription == null ? { minHeight: '140px' } : {}]"
          >
            <div
              v-if="product.isESIM !== null"
              class="sim-ribbon"
              :class="{ esim: product.isESIM, physical: !product.isESIM }"
            >
              <span class="sim-text">
                {{ 
                  product.isESIM 
                    ? 'eSIM' 
                    : 'Φυσική SIM' 
                }}
              </span>
            </div>

            <div class="bold-text1-balance">{{ product.price }}€</div>
            <div class="bold-text2-balance">
              {{ product.description }}
            </div>
            <svg
              class="svg-join-amount"
              width="32px"
              height="32px"
              viewBox="0 0 32 32"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              v-if="product.productDescription != null"
            >
              <desc>Created with Sketch.</desc>
              <g
                id="Icon/Bundle/bonus"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <path
                  d="M24.9278222,32 C27.2041956,32 29.0554667,30.1486222 29.0554667,27.8723556 L29.0554667,11.8766222 C29.0554667,9.60024889 27.2040889,7.74897778 24.9278222,7.74897778 L20.0236444,7.74897778 L22.1514311,5.86147556 C22.8806044,5.21425778 23.2819911,4.34481778 23.2819911,3.41148444 C23.2819911,2.47815111 22.8806044,1.60871111 22.1514311,0.961493333 C20.7056,-0.320462222 18.3512533,-0.320462222 16.9055644,0.961493333 L16.1555556,1.62677333 L15.4069333,0.96288 C13.9611022,-0.319075556 11.6067556,-0.319075556 10.1610667,0.96288 C9.43189333,1.60871111 9.03050667,2.47953778 9.03050667,3.41287111 C9.03050667,4.34620444 9.43189333,5.21564444 10.1610667,5.86286222 L12.2888533,7.75036444 L7.38325333,7.74897564 C5.10688,7.74897564 3.25560889,9.60035342 3.25560889,11.8766201 L3.25560889,27.8723534 C3.25560889,30.1487268 5.10837333,32 7.38325333,32 L24.9278222,32 Z M24.9278222,9.29713529 C26.3500444,9.29713529 27.5083733,10.4541867 27.5083733,11.8777956 L27.5069842,27.8721067 C27.5069842,29.2943289 26.350042,30.4526578 24.9264331,30.4526578 L19.7666108,30.4512686 L19.7666108,9.29713529 L24.9278222,9.29713529 Z M11.1873778,4.70417778 C10.7943111,4.35556622 10.5776711,3.89724444 10.5776711,3.41251556 C10.5776711,2.92778667 10.7943396,2.46947556 11.1873778,2.12085333 C12.0526578,1.35420444 13.5151644,1.35420444 14.3790578,2.12085333 L16.1554489,3.69585778 L17.93184,2.12085333 C18.79712,1.35420444 20.2596267,1.35420444 21.12352,2.12085333 C21.5165867,2.46946489 21.7332267,2.92778667 21.7332267,3.41251556 C21.7332267,3.89724444 21.5165582,4.35555556 21.12352,4.70417778 L17.9596444,7.51111111 C17.8568676,7.60139022 17.742976,7.679168 17.622144,7.75000178 L14.6901973,7.75000178 C14.5693653,7.68055822 14.4554738,7.60278044 14.3526969,7.51111111 L11.1873778,4.70417778 Z M4.80408889,11.8764444 C4.80408889,10.4542222 5.96103111,9.29589333 7.38464,9.29589333 L12.5444622,9.29589333 L12.5444622,30.4514489 L7.38321778,30.4514489 C5.96099556,30.4514489 4.80266667,29.2945067 4.80266667,27.8708978 L4.80408889,11.8764444 Z"
                  id="Shape"
                  fill="#DBE442"
                ></path>
              </g>
            </svg>
            <div class="gift-bonus" v-if="product.productDescription != null">
              {{ product.productDescription }}
            </div>
            <div class="bold-text3-balance" v-if="product.productDescription != null">
              {{ content["f2g.simorder.duration"] }}
            </div>
            <div class="esim-info" v-if="product.isESIM" v-html="content['f2g.simorder.eSIMinfo']"></div>
          </div>
        </div>
      </div>
      <div class="join-steps" v-if="productSelected">
        <div class="mini-title-blue">
          {{ content["f2g.simorder.step3"] }}
        </div>
        <div class="title-overlay4">
          {{ content["f2g.simorder.step3title"] }}
        </div>
        <div class="grid-details-join">
          <div class="row">
            <div class="col-md-6 col-xs-12 col-sm-12">
              <div class="title-form-join">
                {{ content["f2g.simorder.formpersonal"] }}
              </div>
            </div>
            <div class="col-md-6 col-xs-12 col-sm-12">
              <div class="title-form-join">
                {{ content["f2g.simorder.formcontact"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-xs-12 col-sm-12">
              <div class="title-form-join">
                <ValidationProvider
                  :name="content['f2g.simorder.formname']"
                  rules="required|alphaSymbols"
                  v-slot="{ errors }"
                >
                  <div class="form-field">
                    <label class="form-label" for="name">{{
                      content["f2g.simorder.formname"]
                    }}</label>
                    <input
                      type="text"
                      id="name"
                      class="overlay-input-text form-input"
                      v-model="form.name"
                      v-on:click="handleInputClick($event)"
                      v-on:focus="handleInputClick($event)"
                      v-on:blur="handleBlur($event, form.name)"
                    />
                    <span class="element-not-match">{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-6 col-xs-12 col-sm-12">
              <div class="title-form-join">
                <ValidationProvider
                  :name="content['f2g.simorder.formemail']"
                  rules="required|email"
                  v-slot="{ errors }"
                >
                  <div class="form-field">
                    <label class="form-label" for="email">{{
                      content["f2g.simorder.formemail"]
                    }}</label>
                    <input
                      type="text"
                      id="email"
                      class="overlay-input-text form-input"
                      v-model="form.email"
                      v-on:click="handleInputClick($event)"
                      v-on:focus="handleInputClick($event)"
                      v-on:blur="handleBlur($event, form.email)"
                    />
                    <span class="element-not-match">{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-xs-12 col-sm-12">
              <div class="title-form-join">
                <ValidationProvider
                  :name="content['f2g.simorder.formlastname']"
                  rules="required|alphaSymbols"
                  v-slot="{ errors }"
                >
                  <div class="form-field">
                    <label class="form-label" for="lastname">{{
                      content["f2g.simorder.formlastname"]
                    }}</label>
                    <input
                      type="text"
                      id="lastname"
                      class="overlay-input-text form-input"
                      v-model="form.lastName"
                      v-on:click="handleInputClick($event)"
                      v-on:focus="handleInputClick($event)"
                      v-on:blur="handleBlur($event, form.lastName)"
                    />
                    <span class="element-not-match">{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-6 col-xs-12 col-sm-12">
              <div class="title-form-join">
                <ValidationProvider
                  :name="content['f2g.simorder.msisdn']"
                  :rules="{ required: true, regex: /^[6][9][0-9]{8}$/ }"
                  v-slot="{ errors }"
                >
                  <div class="form-field">
                    <label class="form-label" for="msisdn">{{
                      content["f2g.simorder.msisdn"]
                    }}</label>
                    <input
                      type="text"
                      id="msisdn"
                      class="overlay-input-text form-input"
                      v-model="form.msisdn"
                      v-on:click="handleInputClick($event)"
                      v-on:focus="handleInputClick($event)"
                      v-on:blur="handleBlur($event, form.msisdn)"
                    />
                    <span class="element-not-match">{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-xs-12 col-sm-12">
              <div class="title-form-join">
                <ValidationProvider
                  :name="content['f2g.simorder.fathername']"
                  rules="required|alphaSymbols"
                  v-slot="{ errors }"
                >
                  <div class="form-field">
                    <label class="form-label" for="fathername">{{
                      content["f2g.simorder.fathername"]
                    }}</label>
                    <input
                      type="text"
                      id="fathername"
                      class="overlay-input-text form-input"
                      v-model="form.fatherName"
                      v-on:click="handleInputClick($event)"
                      v-on:focus="handleInputClick($event)"
                      v-on:blur="handleBlur($event, form.fatherName)"
                    />
                    <span class="element-not-match">{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-6 col-xs-12 col-sm-12">
              <div class="title-form-join">
                <ValidationProvider
                  :name="content['f2g.simorder.formaddress']"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div class="form-field">
                    <label class="form-label" for="address">{{
                      content["f2g.simorder.formaddress"]
                    }}</label>
                    <input
                      type="text"
                      id="address"
                      class="overlay-input-text form-input"
                      v-model="form.address"
                      v-on:click="handleInputClick($event)"
                      v-on:focus="handleInputClick($event)"
                      v-on:blur="handleBlur($event, form.address)"
                    />
                    <span class="element-not-match">{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-xs-12 col-sm-12">
              <div class="row row-double-input">
                <div class="col-md-3 col-double-input col-xs-12 col-sm-12">
                  <ValidationProvider
                    :name="content['f2g.simorder.formbirthplace']"
                    rules="required|alphaSymbols"
                    v-slot="{ errors }"
                  >
                    <div class="title-form-join">
                      <div class="form-field">
                        <label class="form-label" for="birthplace">{{
                          content["f2g.simorder.formbirthplace"]
                        }}</label>
                        <input
                          type="text"
                          id="birthplace"
                          class="overlay-input-text form-input"
                          v-model="form.birthPlace"
                          v-on:click="handleInputClick($event)"
                          v-on:focus="handleInputClick($event)"
                          v-on:blur="handleBlur($event, form.birthPlace)"
                        />
                        <span class="element-not-match">{{ errors[0] }}</span>
                      </div>
                    </div>
                  </ValidationProvider>
                </div>
                <div class="col-md-3 col-double-input col-xs-12 col-sm-12">
                  <div class="title-form-join">
                    <ValidationProvider
                      :name="content['f2g.simorder.formbirthdate']"
                      rules="required|validDate|minimumAge"
                      v-slot="{ errors }"
                    >
                      <div class="form-field focused">
                        <label class="form-label" for="birthdate">{{
                          content["f2g.simorder.formbirthdate"]
                        }}</label>
                        <input
                          type="text"
                          id="birthdate"
                          class="overlay-input-text form-input"
                          v-model="form.birthDate"
                          :placeholder="calendarPlaceholder"
                        />
                        <span class="element-not-match">{{ errors[0] }}</span>
                      </div>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xs-12 col-sm-12">
              <div class="row row-double-input">
                <div class="col-md-3 col-double-input col-xs-12 col-sm-12">
                  <div class="title-form-join">
                    <ValidationProvider
                      :name="content['f2g.simorder.formcity']"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div class="form-field">
                        <label class="form-label" for="city">{{
                          content["f2g.simorder.formcity"]
                        }}</label>
                        <input
                          type="text"
                          id="city"
                          class="overlay-input-text form-input"
                          v-model="form.city"
                          v-on:click="handleInputClick($event)"
                          v-on:focus="handleInputClick($event)"
                          v-on:blur="handleBlur($event, form.city)"
                        />
                        <span class="element-not-match">{{ errors[0] }}</span>
                      </div>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="col-md-3 col-double-input col-xs-12 col-sm-12">
                  <div class="title-form-join">
                    <ValidationProvider
                      :name="content['f2g.simorder.formpostalcode']"
                      rules="required|digits:5"
                      v-slot="{ errors }"
                    >
                      <div class="form-field">
                        <label class="form-label" for="postalcode">{{
                          content["f2g.simorder.formpostalcode"]
                        }}</label>
                        <input
                          type="text"
                          id="postalcode"
                          class="overlay-input-text form-input"
                          v-model="form.postalCode"
                          v-on:click="handleInputClick($event)"
                          v-on:focus="handleInputClick($event)"
                          v-on:blur="handleBlur($event, form.postalCode)"
                        />
                        <span class="element-not-match">{{ errors[0] }}</span>
                      </div>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-xs-12 col-sm-12">
              <div class="row row-double-input">
                <div class="col-md-3 col-double-input col-xs-12 col-sm-12">
                  <!-- <ValidationProvider name='‘Εγγραφο ταυτοπροσωπίας' rules="required" v-slot="{ errors }"> -->
                  <label class="form-label label-select" for="first">{{
                    content["f2g.simorder.formiddocument"]
                  }}</label>
                  <div class="title-form-join">
                    <div class="custom-select">
                      <select id="iddocument">
                        <option value="0">
                          {{ content["f2g.simorder.formiddocument"] }}
                        </option>
                        <option
                          v-for="(document, index) in identificationDocuments"
                          :key="index"
                          :value="index + 1"
                        >
                          {{ document }}
                        </option>
                      </select>
                    </div>
                    <span id="documentError" class="element-not-match"></span>
                  </div>
                  <!-- <span class="element-not-match">{{errors[0]}}</span> -->
                  <!-- </ValidationProvider> -->
                </div>
                <div class="col-md-3 col-double-input col-xs-12 col-sm-12">
                  <div class="title-form-join">
                    <ValidationProvider
                      :name="content['f2g.simorder.formdocumentnumber']"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div class="form-field">
                        <label class="form-label" for="docno">{{
                          content["f2g.simorder.formdocumentnumber"]
                        }}</label>
                        <input
                          type="text"
                          id="docno"
                          class="overlay-input-text form-input"
                          v-model="form.docno"
                          v-on:click="handleInputClick($event)"
                          v-on:focus="handleInputClick($event)"
                          v-on:blur="handleBlur($event, form.docno)"
                        />
                        <span class="element-not-match">{{ errors[0] }}</span>
                      </div>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xs-12 col-sm-12">
              <div class="title-form-join">
                <ValidationProvider
                  :name="content['f2g.simorder.formcounty']"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div class="form-field">
                    <label class="form-label" for="county">{{
                      content["f2g.simorder.formcounty"]
                    }}</label>
                    <input
                      type="text"
                      id="county"
                      class="overlay-input-text form-input"
                      v-model="form.county"
                      v-on:click="handleInputClick($event)"
                      v-on:focus="handleInputClick($event)"
                      v-on:blur="handleBlur($event, form.county)"
                    />
                    <span class="element-not-match">{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="row row-checkboxes">
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form_checkbox-wrapper">
                <label class="margin-checkbox" @click="validateTerms()">
                  <input type="checkbox" id="ritemb" />
                  <span class="checkbox-icon"></span>
                  <span
                    class="form_checkbox form_checkbox--checkable checkbox-title"
                    v-html="content['f2g.simorder.terms']"
                  >
                  </span>
                </label>
              </div>
              <span id="termsError" class="element-not-match"></span>
            </div>
            <div class="col-md-12 col-xs-12 col-sm-12">
              <div class="form_checkbox-wrapper">
                <label class="margin-checkbox">
                  <input type="checkbox" id="ritemb1" />
                  <span class="checkbox-icon"></span>
                  <span class="form_checkbox form_checkbox--checkable checkbx-title">
                    {{ content["f2g.simorder.newsletter"] }}
                  </span>
                </label>
              </div>
            </div>
          </div>
          <p class="recaptcha-disclaimer">
            This site is protected by reCAPTCHA and the Google
            <a href="https://policies.google.com/privacy">Privacy Policy</a> and
            <a href="https://policies.google.com/terms">Terms of Service</a> apply.
          </p>
          <div id="captcha-box" v-show="captchaVersion == 'v2'">
            <div id="captchaTest"></div>
            <div class="row">
              <div class="col-md-6 col-xs-12">
                <p class="error"><span class="field-validation-error"></span></p>
              </div>
            </div>
          </div>
          <span class="element-not-match">{{ errorMessage }}</span>
        </div>
        <div class="remarks-bundles-details">
          <div class="main-title-bundles">{{ content["f2g.simorder.remarks"] }}</div>
          <span v-html="content['f2g.simorder.remarklist']"></span>
        </div>
      </div>
      <!-- Sticky Footer ******************************************************************************************************-->
      <div class="footer-amount-template" v-if="productSelected">
        <div class="f2g-wind-container footer-amount-bundles-details">
          <div class="white-footer">
            <div class="text-amount">{{ content["f2g.simorder.price"] }}</div>
            <div class="amount-bundles-details">{{ selectedSim.price }},00€</div>
          </div>
          <div class="blue-footer">
            <a
              style="cursor: pointer"
              @click="
                handleSubmit(submitPrepaidOrder);
                validateSelectsAndTerms();
              "
              class="hidden-lg hidden-md"
            >
              <div class="container-button blue-btn">
                {{ content["f2g.simorder.order"] }}
              </div>
            </a>
            <div
              class="hidden-sm hidden-xs"
              style="cursor: pointer"
              @click="
                handleSubmit(submitPrepaidOrder);
                validateSelectsAndTerms();
              "
            >
              {{ content["f2g.simorder.order"] }}
            </div>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
export default {
  name: "Portability",
  props: {
    content: Object,
    mode: String,
    prepaidProducts: Array,
    identificationDocuments: Array,
  },
  data: function () {
    return {
      isStudent: false,
      productSelected: false,
      selectedSim: {},
      orderComplete: false,
      errorMessage: "",
      portability: {
        msisdn: "",
        provider: "",
      },
      form: {
        name: "",
        lastName: "",
        fatherName: "",
        birthPlace: "",
        email: "",
        msisdn: "",
        address: "",
        city: "",
        postalCode: "",
        docno: "",
        county: "",
        birthDate: "",
        document: "",
      },
      date: {
        day: "",
        month: "",
        year: "",
      },
      captchaVersion: "v3",
      widgetId: "",
      modalInitialized: false,
    };
  },
  mounted() {
    if (!$(".all-boxes-card-amount").hasClass("slick-slider")) {
      $(".all-boxes-card-amount").slick({
        infinite: false,
        variableWidth: true,
        arrows: false,
        slidesToShow: 4,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }
    if ($(".open-as-modal") !== null && this.modalInitialized === false) {
      //initialize terms modal
      $(".open-as-modal").each(function (index, value) {
        $(this).animatedModal({
          animatedIn: 'bounceIn',
          animatedOut: 'bounceOut',
          animationDuration: '.6s',
          color: '#FFFFFF',
          // Callbacks
          beforeOpen: function () {
          },
          afterOpen: function () {
          },
          beforeClose: function () {
          },
          afterClose: function () {
          }
        });
      });
      this.modalInitialized = true;
    }
    this.setEqualHeights();
    window.addEventListener('resize', this.setEqualHeights);
  },
  computed: {
    calendarPlaceholder() {
      if ($("body").data("locale") == "en_US") {
        return "dd/mm/yyyy";
      } else {
        return "ΗΗ/ΜΜ/ΕΕΕΕ";
      }
    },
  },
  updated() {
    this.initDropdowns();
    // this.initInputs();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setEqualHeights);
  },
  methods: {
    handleInputClick(evt) {
      $(evt.target).parents(".form-field").addClass("focused");
    },
    handleBlur(evt, value) {
      if (value == "") {
        $(evt.target).parents(".form-field").removeClass("focused");
      }
    },
    selectProduct(event) {
      var products = document.querySelectorAll(".box-card-amount");

      [].forEach.call(products, function (el) {
        el.classList.remove("active-blue-line");
      });

      var simID;
      if (event.target.className == ".box-card-amount") {
        event.target.classList.add("active-blue-line");
        simID = event.target.id;
      } else {
        event.target.closest(".box-card-amount").classList.add("active-blue-line");
        simID = event.target.closest(".box-card-amount").id;
      }

      var self = this;
      this.prepaidProducts.forEach(function (product) {
        if (product.id == simID) self.selectedSim = product;
      });
      this.productSelected = true;
      this.$forceUpdate();
    },
    initDropdowns() {
      var self = this;
      var x, i, j, selElmnt, a, b, c;
      /*look for any elements with the class "custom-select":*/
      x = document.getElementsByClassName("custom-select");
      for (i = 0; i < x.length; i++) {
        if (
          !x[i].getElementsByTagName("select")[0].classList.contains("select-converted")
        ) {
          selElmnt = x[i].getElementsByTagName("select")[0];
          selElmnt.classList.add("select-converted");
          /*for each element, create a new DIV that will act as the selected item:*/
          a = document.createElement("DIV");
          a.setAttribute("class", "select-selected");
          a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
          x[i].appendChild(a);
          /*for each element, create a new DIV that will contain the option list:*/
          b = document.createElement("DIV");
          b.setAttribute("class", "select-items select-hide");
          for (j = 1; j < selElmnt.length; j++) {
            /*for each option in the original select element,
                  create a new DIV that will act as an option item:*/
            c = document.createElement("DIV");
            c.innerHTML = selElmnt.options[j].innerHTML;
            c.addEventListener("click", function () {
              /*when an item is clicked, update the original select box,
                    and the selected item:*/
              var y, i, k, s, h;
              s = this.parentNode.parentNode.getElementsByTagName("select")[0];
              h = this.parentNode.previousSibling;
              for (i = 0; i < s.length; i++) {
                if (s.options[i].innerHTML == this.innerHTML) {
                  s.selectedIndex = i;
                  h.innerHTML = this.innerHTML;
                  y = this.parentNode.getElementsByClassName("same-as-selected");
                  for (k = 0; k < y.length; k++) {
                    y[k].removeAttribute("class");
                  }
                  this.setAttribute("class", "same-as-selected");
                  break;
                }
              }
              h.click();
              if (c.parentNode.childElementCount > 2) {
                self.validateDocument();
              } else {
                self.validatePortability();
              }
            });
            b.appendChild(c);
          }
          x[i].appendChild(b);
          a.addEventListener("click", function (e) {
            /*when the select box is clicked, close any other select boxes,
                  and open/close the current select box:*/
            e.stopPropagation();
            closeAllSelect(this);
            this.nextSibling.classList.toggle("select-hide");
            this.classList.toggle("select-arrow-active");
          });
        }
      }
      function closeAllSelect(elmnt) {
        /*a function that will close all select boxes in the document,
         except the current select box:*/
        var x,
          y,
          i,
          arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        for (i = 0; i < y.length; i++) {
          if (elmnt == y[i]) {
            arrNo.push(i);
          } else {
            y[i].classList.remove("select-arrow-active");
          }
        }
        for (i = 0; i < x.length; i++) {
          if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
          }
        }
      }
      document.addEventListener("click", closeAllSelect);
    },
    initInputs() {
      /* $('input').focus(function(){
            $(this).parents('.form-field').addClass('focused');
         });
         
         $('input').blur(function(){
            var inputValue = $(this).val();
            if ( inputValue == "" ) {
               $(this).removeClass('filled');
               $(this).parents('.form-field').removeClass('focused');
            } else {
               $(this).addClass('filled');
            }
         })*/
    },
    submitPrepaidOrder() {
      var locale = document.getElementsByTagName("body")[0].dataset.locale
        ? document.getElementsByTagName("body")[0].dataset.locale
        : "el_GR";
      if (this.validateSelectsAndTerms()) {
        if (this.validateCaptcha()) {
          this.$store.commit("showLoader");
          var self = this;
          this.getDateParams();
          var payload = this.prepareRequest();
          var v3Key = document.getElementsByTagName("body")[0].dataset.captchav3;
          payload.captchaVersion = self.captchaVersion;
          grecaptcha.execute(v3Key, { action: "f2gsimorder" }).then(function (token) {
            payload.captchaToken = token;
            if (self.captchaVersion == "v2") {
              payload.captchaToken = grecaptcha.getResponse(self.widgetId);
            }
            payload.captchaVersion = self.captchaVersion;
            self.axios
              .post(`/apiv2/prepaidcustomer/submitPrepaidOrder/`, payload)
              .then((response) => {
                if (response.data.errorLevel == 0) {
                  var dataLayerObj = {
                    event: "sim-order",
                    "type-of-number": self.mode == "portability" ? "portability" : "new",
                    "sim-value": self.selectedSim.price.toFixed(2),
                    currency: "EUR",
                    foititiko: self.isStudent ? "yes" : "no",
                  };
                  handleDataLayer.init();
                  handleDataLayer.pushDataLayer(dataLayerObj);
                  self.$store.commit("hideLoader");
                  self.$emit("orderComplete", true);
                } else if (response.data.errorCode == 7012) {
                  if (self.captchaVersion != "v2") {
                    var v2Key = document.getElementsByTagName("body")[0].dataset
                      .captchav2;
                    grecaptcha.ready(() => {
                      self.widgetId = grecaptcha.render("captchaTest", {
                        sitekey: v2Key,
                        theme: "light",
                      });
                    });
                  }
                  self.captchaVersion = "v2";
                  self.$store.commit("hideLoader");
                } else {
                  console.log(`Error: ${response.data.errorMessage}`);
                  self.errorMessage =
                    locale == "en_US"
                      ? "Something went wrong, please try again."
                      : "Κάτι πήγε στραβά, παρακαλούμε δοκίμασε ξανά.";
                  self.$store.commit("hideLoader");
                }
              })
              .catch((error) => {
                console.log(error);
                self.errorMessage =
                  locale == "en_US"
                    ? "Something went wrong, please try again."
                    : "Κάτι πήγε στραβά, παρακαλούμε δοκίμασε ξανά.";
                self.$store.commit("hideLoader");
              });
          });
        }
      }
    },
    validateTerms() {
      var locale = document.getElementsByTagName("body")[0].dataset.locale
        ? document.getElementsByTagName("body")[0].dataset.locale
        : "el_GR";
      var termsSelected = true;
      if (document.getElementById("ritemb").checked == false) {
        document.getElementById("termsError").innerHTML =
          locale == "en_US"
            ? "Please accept the terms of use."
            : "Η αποδοχή των όρων της προσφοράς είναι υποχρεωτική.";
        termsSelected = false;
      } else {
        document.getElementById("termsError").innerHTML = "";
      }

      return termsSelected;
    },
    validatePortability() {
      var locale = document.getElementsByTagName("body")[0].dataset.locale
        ? document.getElementsByTagName("body")[0].dataset.locale
        : "el_GR";
      var portabilitySelected = true;
      if (document.getElementById("portability") != null) {
        var sel = document.getElementById("portability");
        if (sel.options[sel.selectedIndex].value == 0) {
          document.getElementById("providerError").innerHTML =
            locale == "en_US"
              ? "Please fill in the Current Provider"
              : "Παρακαλούμε συμπλήρωσε το πεδίο Υπάρχων Πάροχος";
          portabilitySelected = false;
        } else {
          this.portability.provider = sel.options[sel.selectedIndex].text;
          document.getElementById("providerError").innerHTML = "";
        }
      }

      return portabilitySelected;
    },
    validateDocument() {
      var locale = document.getElementsByTagName("body")[0].dataset.locale
        ? document.getElementsByTagName("body")[0].dataset.locale
        : "el_GR";
      var documentSelected = true;

      if (document.getElementById("iddocument") != null) {
        var select = document.getElementById("iddocument");
        if (select.options[select.selectedIndex].value == 0) {
          document.getElementById("documentError").innerHTML =
            locale == "en_US"
              ? "Please fill in the Identification Document"
              : "Παρακαλούμε συμπλήρωσε το πεδίο ‘Εγγραφο ταυτοπροσωπίας";
          documentSelected = false;
        } else {
          this.document = this.identificationDocuments[
            select.options[select.selectedIndex].value - 1
          ];
          document.getElementById("documentError").innerHTML = "";
        }
      }

      return documentSelected;
    },
    validateSelectsAndTerms() {
      var terms = this.validateTerms();
      var select1 = this.validatePortability();
      var select2 = this.validateDocument();

      return terms && select1 && select2;
    },
    validateCaptcha() {
      if (
        this.captchaVersion == "v2" &&
        grecaptcha.getResponse(this.widgetId).length == 0
      ) {
        $("body").data("locale") == "el_GR"
          ? $("#captcha-box > div > div > p > span").html(
              "To captcha πρέπει να συμπληρωθεί."
            )
          : $("#captcha-box > div > div > p > span").html("Please fill in the captcha.");
        $("#captcha-box > div > div > p > span").show();
      } else {
        $("#captcha-box > div > div > p > span").html("");
        $("#captcha-box > div > div > p > span").hide();
      }
      return (
        this.captchaVersion == "v3" || grecaptcha.getResponse(this.widgetId).length != 0
      );
    },
    prepareRequest() {
      //prepare request
      var request = {};
      request.caller = {};

      //Set caller
      //Replace values
      request.caller.callingSystem = "WINDweb";
      request.caller.salesCode = "";
      request.caller.username = "username";
      request.caller.locale = document.getElementsByTagName("body")[0].dataset.locale
        ? document.getElementsByTagName("body")[0].dataset.locale
        : "el_GR";
      request.caller.channel = "F2G";
      request.caller.data = "";

      request.orderType = "f2gsimorder";

      request.products = [];
      var product = {};
      product.productId = this.selectedSim.id;
      product.productName = this.selectedSim.title;
      product.productType = this.selectedSim.productDescription;
      product.portability = this.mode == "portability";
      if (product.portability) {
        product.oldMsisdn = this.portability.msisdn;
        product.provider = this.portability.provider;
      }
      request.products.push(product);

      request.name = this.form.name;
      request.surname = this.form.lastName;
      request.fathersName = this.form.fatherName;
      request.email = this.form.email;
      request.contactPhone = this.form.msisdn;
      request.deliveryRoadNumber = this.form.address;
      request.city = this.form.city;
      request.zipCode = this.form.postalCode;
      request.county = this.form.county;
      request.birthPlace = this.form.birthPlace;
      request.identificationDocument = this.document;
      request.documentNumber = this.form.docno;
      request.newsletter = document.getElementById("ritemb1").checked;

      var dayOfBirth = this.date.day;
      var monthOfBirth = this.date.month;
      var yearOfBirth = this.date.year;
      var birthDate = yearOfBirth + "-" + monthOfBirth + "-" + dayOfBirth;
      request.birthDate = birthDate;
      request.isStudent = this.isStudent;

      return request;
    },
    getDateParams() {
      var date1 = this.form.birthDate.split("/");
      var date2 = this.form.birthDate.split("-");
      var date3 = this.form.birthDate.split(".");
      var len1 = date1.length;
      var len2 = date2.length;
      if (len1 > 1) {
        if (date1[0].length == 1) {
          this.date.day = "0" + date1[0];
        } else {
          this.date.day = date1[0];
        }
        if (date1[1].length == 1) {
          this.date.month = "0" + date1[1];
        } else {
          this.date.month = date1[1];
        }
        if (date1[2].length == 2) {
          this.date.year = "19" + date1[2];
        } else {
          this.date.year = date1[2];
        }
      } else if (len2 > 1) {
        if (date2[0].length == 1) {
          this.date.day = "0" + date2[0];
        } else {
          this.date.day = date2[0];
        }
        if (date2[1].length == 1) {
          this.date.month = "0" + date2[1];
        } else {
          this.date.month = date2[1];
        }
        if (date2[2].length == 2) {
          this.date.year = "19" + date2[2];
        } else {
          this.date.year = date2[2];
        }
      } else {
        if (date3[0].length == 1) {
          this.date.day = "0" + date3[0];
        } else {
          this.date.day = date3[0];
        }
        if (date3[1].length == 1) {
          this.date.month = "0" + date3[1];
        } else {
          this.date.month = date3[1];
        }
        if (date3[2].length == 2) {
          this.date.year = "19" + date3[2];
        } else {
          this.date.year = date3[2];
        }
      }
    },
    setEqualHeights() {
      this.$nextTick(() => {
        const elements = this.$el.querySelectorAll('.box-card-amount');
        let maxHeight = 0;

        elements.forEach(el => {
          el.style.height = 'auto';
        });

        elements.forEach(el => {
          if (el.offsetHeight > maxHeight) {
            maxHeight = el.offsetHeight;
          }
        });

        elements.forEach(el => {
          el.style.height = maxHeight + 'px';
        });
      });
    }
  },
};
</script>

<style>
.grecaptcha-badge {
  display: none;
}

p.recaptcha-disclaimer {
  font-family: Manrope-Normal;
  color: #ada8a0;
  font-size: 1.4rem;
  line-height: 1.9rem;
  padding: 25px 0;
}

p.recaptcha-disclaimer a {
  color: #ada8a0;
  text-decoration: underline;
}

.sim-ribbon {
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 70px 70px 0 0;
  border-top-left-radius: 6px;
  top: 0;
  left: 0;
  z-index: 2;
}

.sim-ribbon.esim {
  border-color: #00bcd4 transparent transparent transparent;
}

.sim-ribbon.physical {
  border-color: #9e9e9e transparent transparent transparent;
}

.sim-text {
  position: absolute;
  left: 0;
  width: 45px;
  font-weight: bold;
  color: white;
  text-align: center;
  transform: rotate(-45deg);
  pointer-events: none;
}

.sim-ribbon.esim .sim-text {
  bottom: 37px;
  font-size: 14px;
}

.sim-ribbon.physical .sim-text {
  bottom: 32px;
  font-size: 11px;
}

.esim-info {
  font-family: Manrope-Normal;
  font-size: 12px;
}
</style>
